import { commonComponentConfigurations, commonCallableComponentConfigurations, MULTIPLE_ANSWERS } from '../common';
var bcName = commonComponentConfigurations.bcName,
  worktimes = commonComponentConfigurations.worktimes,
  birthYear = commonComponentConfigurations.birthYear,
  availabilityDate = commonComponentConfigurations.availabilityDate,
  additionalBenefits = commonComponentConfigurations.additionalBenefits,
  companyCulture = commonComponentConfigurations.companyCulture,
  generatedExternalName = commonComponentConfigurations.generatedExternalName,
  wizardBcRegistration = commonComponentConfigurations.wizardBcRegistration,
  wizardBcDirectRegistration = commonComponentConfigurations.wizardBcDirectRegistration,
  externalName = commonComponentConfigurations.externalName,
  internalName = commonComponentConfigurations.internalName,
  AN1 = commonComponentConfigurations.AN1,
  UN1 = commonComponentConfigurations.UN1,
  AU1 = commonComponentConfigurations.AU1,
  WM1 = commonComponentConfigurations.WM1,
  FL1 = commonComponentConfigurations.FL1,
  GE11 = commonComponentConfigurations.GE11,
  GE12 = commonComponentConfigurations.GE12,
  EX11 = commonComponentConfigurations.EX11,
  EX12 = commonComponentConfigurations.EX12,
  AZ1 = commonComponentConfigurations.AZ1,
  name = commonComponentConfigurations.name,
  phone = commonComponentConfigurations.phone,
  emailSingle = commonComponentConfigurations.emailSingle,
  phoneVerification = commonComponentConfigurations.phoneVerification;
var salary = commonCallableComponentConfigurations.salary,
  location = commonCallableComponentConfigurations.location,
  wizardLocation = commonCallableComponentConfigurations.wizardLocation,
  workExperience = commonCallableComponentConfigurations.workExperience,
  languages = commonCallableComponentConfigurations.languages;
var profilePrefix = 'profile-properties:logistics-scheduler.';
var componentConfigurations = {
  locationWithoutRadius: location({
    translationPrefix: 'common',
    withRadius: false
  }),
  wizardLocationWithoutRadius: wizardLocation({
    translationPrefix: 'common',
    withRadius: false
  }),
  cargo: {
    component: 'MultipleChoice',
    valueType: 'Array',
    valueName: 'cargo',
    defaultValue: [],
    options: {
      ROAD: profilePrefix + 'cargo.ROAD',
      RAIL: profilePrefix + 'cargo.RAIL',
      SEA: profilePrefix + 'cargo.SEA',
      AIR: profilePrefix + 'cargo.AIR'
    },
    mandatory: false,
    translations: {
      text: 'logistics-scheduler.cargo.text',
      hint: MULTIPLE_ANSWERS,
      label: 'logistics-scheduler.cargo.label'
    }
  },
  location: {
    component: 'Location',
    valueType: 'LocationType',
    valueName: 'location',
    withRadius: false,
    defaultValue: {},
    mandatory: true,
    translations: {
      text: 'common.location.text',
      inputText: 'logistics-scheduler.location.inputText',
      label: 'logistics-scheduler.location.label',
      hint: 'logistics-scheduler.location.hint'
    }
  },
  workPosition: {
    component: 'MultipleChoice',
    valueType: 'Array',
    valueName: 'workPosition',
    defaultValue: [],
    options: {
      EMPLOYEE: profilePrefix + 'workPosition.EMPLOYEE',
      LEAD: profilePrefix + 'workPosition.LEAD'
    },
    icon: 'People',
    mandatory: false,
    translations: {
      label: 'logistics-scheduler.workPosition.label',
      text: 'logistics-scheduler.workPosition.text',
      hint: MULTIPLE_ANSWERS
    }
  },
  salary: salary({
    defaultValue: {
      minimum: 2000,
      maximum: 2850
    },
    range: {
      minimum: 1550,
      maximum: 6000
    },
    translations: {
      label: 'common.salary.label',
      text: 'common.salary.text',
      hint: 'common.salary.hint',
      brutto: 'common.salary.brutto',
      currency: 'common.salary.currency'
    }
  }),
  languages: languages({}),
  optionalLanguages: languages({
    unsetOption: true
  }),
  training: {
    component: 'MultipleChoice',
    valueType: 'Array',
    valueName: 'training',
    defaultValue: [],
    options: {
      LOGISTICS_MANAGER: profilePrefix + 'training.LOGISTICS_MANAGER',
      OTHER_COMMERCIAL_TRAINING: profilePrefix + 'training.OTHER_COMMERCIAL_TRAINING',
      TRUCK_DRIVER: profilePrefix + 'training.TRUCK_DRIVER',
      BUSINESS_ECONOMIST: profilePrefix + 'training.BUSINESS_ECONOMIST',
      STUDY: profilePrefix + 'training.STUDY',
      NONE: profilePrefix + 'training.NONE'
    },
    icon: 'School',
    mandatory: false,
    translations: {
      label: 'logistics-scheduler.training.label',
      text: 'logistics-scheduler.training.text',
      hint: MULTIPLE_ANSWERS
    },
    educationTooltip: {
      content: 'logistics-scheduler.training.info',
      target: 'training',
      offset: 10,
      position: 7,
      placement: 'auto',
      visibleFor: 'bc'
    }
  },
  goods: {
    component: 'MultipleChoice',
    valueType: 'Array',
    valueName: 'goods',
    defaultValue: [],
    options: {
      BUILDING_MATERIALS: profilePrefix + 'goods.BUILDING_MATERIALS',
      LIQUIDS: profilePrefix + 'goods.LIQUIDS',
      DANGEROUS_GOODS: profilePrefix + 'goods.DANGEROUS_GOODS',
      FOOD: profilePrefix + 'goods.FOOD',
      RELOCATION: profilePrefix + 'goods.RELOCATION',
      BULK_GOODS: profilePrefix + 'goods.BULK_GOODS',
      HEAVY_HAULAGE: profilePrefix + 'goods.HEAVY_HAULAGE',
      GENERAL_CARGO: profilePrefix + 'goods.GENERAL_CARGO',
      PARTIAL_AND_FULL_LOADS: profilePrefix + 'goods.PARTIAL_AND_FULL_LOADS'
    },
    icon: 'School',
    mandatory: false,
    translations: {
      label: 'logistics-scheduler.goods.label',
      text: 'logistics-scheduler.goods.text',
      hint: MULTIPLE_ANSWERS
    }
  },
  workExperience: workExperience({
    translationPrefix: 'logistics-scheduler',
    defaultValue: null
  }),
  worktimes: worktimes,
  birthYear: birthYear,
  availabilityDate: availabilityDate,
  tasks: {
    component: 'LongText',
    valueType: 'DescriptionString',
    identifier: 'tasks',
    valueName: 'descriptions',
    defaultValue: {},
    icon: 'Dns',
    mandatory: false,
    translations: {
      label: 'logistics-scheduler.tasks.label',
      text: 'logistics-scheduler.tasks.text',
      inputField: 'logistics-scheduler.tasks.inputField'
    }
  },
  wizardTasks: {
    component: 'LongText',
    valueType: 'DescriptionString',
    identifier: 'tasks',
    valueName: 'descriptions',
    defaultValue: {},
    icon: 'Dns',
    mandatory: false,
    translations: {
      label: 'logistics-scheduler.tasks.label',
      text: 'logistics-scheduler.tasks.text',
      inputField: 'logistics-scheduler.tasks.inputField',
      hint: 'common.wizardDafaultHint.hint'
    },
    educationTooltip: {
      content: 'common.tasks.info',
      target: 'wizardTasks',
      offset: 10,
      position: 5,
      placement: 'auto',
      visibleFor: 'bc'
    }
  },
  additionalBenefits: additionalBenefits,
  companyCulture: companyCulture,
  externalName: externalName,
  internalName: internalName,
  generatedExternalName: generatedExternalName,
  wizardBcRegistration: wizardBcRegistration,
  wizardBcDirectRegistration: wizardBcDirectRegistration,
  bcName: bcName,
  // Diagnostics
  AN1: AN1,
  UN1: UN1,
  AU1: AU1,
  WM1: WM1,
  FL1: FL1,
  GE11: GE11,
  GE12: GE12,
  EX11: EX11,
  EX12: EX12,
  AZ1: AZ1,
  // Personal information of the PC registration
  name: name,
  phone: phone,
  emailSingle: emailSingle,
  phoneVerification: phoneVerification
};
export var pc = {
  discriminator: 'logistics-scheduler',
  version: '1.0.0',
  target: 'pc',
  vertical: {
    de: 'disponenten',
    pl: 'dyspozytorzy',
    at: 'disponenten',
    en: 'logistics-scheduler'
  },
  // Components used in this configuration
  componentConfigurations: componentConfigurations,
  translationConfiguration: {
    namespace: 'pc-funnel'
  },
  funnel: [{
    steps: [{
      componentConfiguration: 'cargo'
    }, {
      componentConfiguration: 'worktimes'
    }, {
      componentConfiguration: 'workPosition'
    }, {
      componentConfiguration: 'salary'
    }, {
      componentConfiguration: 'location'
    }, {
      componentConfiguration: 'training'
    }, {
      componentConfiguration: 'goods'
    }, {
      componentConfiguration: 'workExperience'
    }, {
      componentConfiguration: 'languages'
    }, {
      componentConfiguration: 'birthYear'
    }, {
      componentConfiguration: 'availabilityDate'
    }]
  }, {
    translations: {
      text: 'common.funnelSeparator2.text',
      description: 'common.funnelSeparator2.description',
      nextButton: 'common.funnelSeparator2.nextButton'
    },
    steps: [{
      componentConfiguration: 'AN1'
    }, {
      componentConfiguration: 'UN1'
    }, {
      componentConfiguration: 'AU1'
    }, {
      componentConfiguration: 'WM1'
    }, {
      componentConfiguration: 'FL1'
    }, {
      componentConfiguration: 'AZ1'
    }]
  }],
  simplifiedFunnelQuestions: [{
    steps: []
  }, {
    translations: {
      text: 'common.funnelSeparatorSimpflified.text',
      description: 'common.funnelSeparatorSimpflified.description',
      nextButton: 'common.funnelSeparatorSimpflified.nextButton'
    },
    steps: [{
      componentConfiguration: 'cargo'
    }, {
      componentConfiguration: 'worktimes'
    }, {
      componentConfiguration: 'workPosition'
    }, {
      componentConfiguration: 'salary'
    }, {
      componentConfiguration: 'location'
    }, {
      componentConfiguration: 'training'
    }, {
      componentConfiguration: 'goods'
    }, {
      componentConfiguration: 'workExperience'
    }, {
      componentConfiguration: 'languages'
    }, {
      componentConfiguration: 'birthYear'
    }, {
      componentConfiguration: 'availabilityDate'
    }]
  }],
  registration: [{
    userAttributes: {
      phone_number: 'phone',
      name: 'name',
      gender: 'gender'
    },
    steps: [{
      componentConfiguration: 'name'
    }, {
      componentConfiguration: 'emailSingle'
    }, {
      componentConfiguration: 'phone'
    }, {
      componentConfiguration: 'phoneVerification'
    }]
  }],
  edit: [{
    key: 'subtitle1',
    type: 'subtitle',
    translations: {
      headline: 'pc-funnel:care.edit.subtitle1.headline'
    }
  }, {
    type: 'item',
    componentConfiguration: 'cargo'
  }, {
    type: 'item',
    componentConfiguration: 'languages'
  }, {
    type: 'item',
    componentConfiguration: 'worktimes'
  }, {
    type: 'item',
    componentConfiguration: 'workPosition'
  }, {
    type: 'item',
    componentConfiguration: 'salary'
  }, {
    type: 'item',
    componentConfiguration: 'location'
  }, {
    key: 'subtitle2',
    type: 'subtitle',
    translations: {
      headline: 'pc-funnel:care.edit.subtitle2.headline'
    }
  }, {
    type: 'item',
    componentConfiguration: 'training'
  }, {
    type: 'item',
    componentConfiguration: 'goods'
  }, {
    type: 'item',
    componentConfiguration: 'workExperience'
  }, {
    type: 'item',
    componentConfiguration: 'birthYear'
  }, {
    type: 'item',
    componentConfiguration: 'availabilityDate'
  }, {
    key: 'subtitle3',
    type: 'subtitle',
    translations: {
      headline: 'pc-funnel:care.edit.subtitle3.headline'
    }
  }, {
    key: 'diagnosticBlock',
    componentConfiguration: '',
    type: 'block',
    translations: {
      description: 'pc-funnel:care.edit.diagnosticBlock.description'
    },
    items: [{
      steps: [{
        componentConfiguration: 'AN1'
      }, {
        componentConfiguration: 'UN1'
      }, {
        componentConfiguration: 'AU1'
      }, {
        componentConfiguration: 'WM1'
      }, {
        componentConfiguration: 'FL1'
      }, {
        componentConfiguration: 'GE11'
      }, {
        componentConfiguration: 'GE12'
      }, {
        componentConfiguration: 'EX11'
      }, {
        componentConfiguration: 'EX12'
      }, {
        componentConfiguration: 'AZ1'
      }]
    }]
  }],
  startFreeWizard: [],
  startDirectActivationWizard: [],
  view: {
    profileFields: ['worktimes',
    // 1 right
    'training',
    // 1 left
    'cargo',
    // 2 right
    'workExperience',
    // 2 left
    'workPosition',
    // 3 right
    'goods',
    // 3 left
    'salary',
    // 4 right
    'birthYear',
    // 4 left
    'location',
    // 5 left
    'languages'],
    profileListFields: ['name', 'education', 'distance', 'phone', 'email', 'date'],
    primaryAttribute: 'goods',
    translatedStringFields: ['workExperience']
  }
};
var wizardLogic = function wizardLogic(type) {
  return [{
    steps: [{
      componentConfiguration: 'wizardLocationWithoutRadius',
      mandatory: true
    }, {
      componentConfiguration: 'bcName',
      mandatory: true
    }, {
      componentConfiguration: 'generatedExternalName',
      mandatory: true
    }, {
      componentConfiguration: type,
      mandatory: true
    }]
  }];
};
export var bc = {
  discriminator: 'logistics-scheduler',
  version: '1.0.1',
  target: 'bc',
  // Components used in this configuration
  componentConfigurations: componentConfigurations,
  translationConfiguration: {
    namespace: 'bc-dashboard'
  },
  funnel: [{
    steps: [{
      componentConfiguration: 'locationWithoutRadius',
      mandatory: true
    }, {
      componentConfiguration: 'workPosition',
      mandatory: false
    }, {
      componentConfiguration: 'training',
      mandatory: false
    }, {
      componentConfiguration: 'cargo',
      mandatory: false
    }, {
      componentConfiguration: 'worktimes',
      mandatory: false
    }, {
      componentConfiguration: 'workExperience',
      mandatory: false
    }, {
      componentConfiguration: 'optionalLanguages'
    }, {
      componentConfiguration: 'salary',
      mandatory: false
    }]
  }, {
    translations: {
      text: 'common.funnelSeparatorAudienceDone.text',
      description: 'common.funnelSeparatorAudienceDone.description',
      nextButton: 'common.funnelSeparatorAudienceDone.nextButton'
    },
    steps: [{
      componentConfiguration: 'goods',
      mandatory: false
    }, {
      componentConfiguration: 'tasks',
      mandatory: false
    }, {
      componentConfiguration: 'additionalBenefits',
      mandatory: false
    }, {
      componentConfiguration: 'companyCulture',
      mandatory: false
    }, {
      componentConfiguration: 'internalName',
      mandatory: false
    }, {
      componentConfiguration: 'generatedExternalName',
      mandatory: false
    }]
  }, {
    translations: {
      text: 'common.funnelSeparator1.text',
      description: 'common.funnelSeparator1.description',
      nextButton: 'common.funnelSeparator1.nextButton',
      skipButton: 'common.funnelSeparator1.skipButton'
    },
    steps: [{
      componentConfiguration: 'AN1',
      mandatory: false
    }, {
      componentConfiguration: 'UN1',
      mandatory: false
    }, {
      componentConfiguration: 'AU1',
      mandatory: false
    }, {
      componentConfiguration: 'WM1',
      mandatory: false
    }, {
      componentConfiguration: 'FL1',
      mandatory: false
    }]
  }],
  simplifiedFunnelQuestions: [],
  startFreeWizard: wizardLogic('wizardBcRegistration'),
  startDirectActivationWizard: wizardLogic('wizardBcDirectRegistration'),
  edit: [{
    key: 'subtitle',
    type: 'subtitle',
    translations: {
      headline: 'bc-dashboard:JobofferEdit.AudienceHeadline'
    }
  }, {
    type: 'item',
    componentConfiguration: 'locationWithoutRadius',
    disabled: function disabled(value) {
      return !!value.name && !!value.latitude && !!value.longitude;
    }
  }, {
    type: 'item',
    componentConfiguration: 'training'
  }, {
    type: 'item',
    componentConfiguration: 'workPosition'
  }, {
    type: 'item',
    componentConfiguration: 'cargo'
  }, {
    type: 'item',
    componentConfiguration: 'worktimes'
  }, {
    type: 'item',
    componentConfiguration: 'workExperience'
  }, {
    type: 'item',
    componentConfiguration: 'optionalLanguages'
  }, {
    type: 'item',
    componentConfiguration: 'salary'
  }, {
    type: 'item',
    componentConfiguration: 'goods'
  }, {
    key: 'subtitle',
    type: 'subtitle',
    translations: {
      headline: 'bc-dashboard:JobofferEdit.AdvertHeadline'
    }
  }, {
    type: 'item',
    componentConfiguration: 'tasks',
    isEmpty: function isEmpty(value) {
      return !value || !value.tasks;
    }
  }, {
    type: 'item',
    componentConfiguration: 'additionalBenefits',
    isEmpty: function isEmpty(value) {
      return !value || !value.additionalBenefits;
    }
  }, {
    type: 'item',
    componentConfiguration: 'companyCulture',
    isEmpty: function isEmpty(value) {
      return !value || !value.companyCulture;
    }
  }, {
    type: 'item',
    componentConfiguration: 'internalName',
    isEmpty: function isEmpty() {
      return false;
    }
  }, {
    type: 'item',
    componentConfiguration: 'externalName',
    isEmpty: function isEmpty() {
      return false;
    }
  }, {
    key: 'subtitle',
    type: 'subtitle',
    translations: {
      headline: 'bc-dashboard:JobofferEdit.CultureHeadline'
    }
  }, {
    type: 'item',
    componentConfiguration: 'AN1'
  }, {
    type: 'item',
    componentConfiguration: 'UN1'
  }, {
    type: 'item',
    componentConfiguration: 'AU1'
  }, {
    type: 'item',
    componentConfiguration: 'WM1'
  }, {
    type: 'item',
    componentConfiguration: 'FL1'
  }, {
    key: 'subtitle',
    type: 'subtitle',
    translations: {
      headline: 'bc-dashboard:JobofferEdit.SettingsHeadline',
      headlineFreemium: 'bc-dashboard:JobofferEdit.SettingsHeadlineFreemium',
      description: 'bc-dashboard:JobofferEdit.SettingsDescription'
    }
  }],
  view: {
    primaryAttribute: 'training'
  }
};
export default {
  pc: pc,
  bc: bc
};